import { render, staticRenderFns } from "./CompletarFrase.vue?vue&type=template&id=cc8ea53a&scoped=true&"
import script from "./CompletarFrase.vue?vue&type=script&lang=js&"
export * from "./CompletarFrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8ea53a",
  null
  
)

export default component.exports